import axios from 'axios';

export const actions = {
    async store(vuexContext, payload) {
        return axios.$post('/v1/account_events', payload);
    }
};
